export default __webpack_public_path__ + "static/media/low_utilization_bg.9f50c7df.png";